import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgPlay = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	color: "#0f1826",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M13.0233 7.8L5.1103 1.86523C4.94549 1.74162 4.7103 1.85922 4.7103 2.06523V13.9348C4.7103 14.1408 4.94549 14.2584 5.1103 14.1348L13.0233 8.2C13.1567 8.1 13.1567 7.9 13.0233 7.8Z",
		stroke: "currentColor"
	})
});
export default SvgPlay;
